export default {
  "upcomingFlows": {
    "upcoming_flows": "Upcoming flows",
    "next_run_moment_format": "ddd DD MMM, YYYY [at] hh:mm A",
    "last_sync_moment_format": "MMMM DD, YYYY hh:mm A",
    "upcoming_time_moment_format": "hh:mm A"
  }
};
